import { Box, Heading, Text } from '@wix/design-system'
import { useContent, useNext, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC } from 'react'

import { usePageLogger } from '../../../bi/mfi'
import { CommonTemplate } from '../../reusable/CommonTemplate/CommonTemplate'
import WixLogo from '../../reusable/icons/WixLogo.svg'
import { Option } from './Option'
import { TWixelSplit } from './WixelSplit.content'
import { wixelSplitDataHooks } from './WixelSplit.dataHooks'
import s from './WixelSplit.scss'

export const WixelSplit: FC = () => {
  const [isPageLoading] = usePageLoading()
  const next = useNext()
  const { content } = useContent<TWixelSplit>()
  const { question } = content
  const pageLogger = usePageLogger()

  const handleClick = (questionKey: string, optionKey: string) => () => {
    if (isPageLoading) {
      return
    }

    void pageLogger.answer({ questionName: questionKey, answer: optionKey })
    next({
      [questionKey]: { values: [optionKey] },
    })
  }

  const handleSkipClick = () => {
    void pageLogger.answer({ questionName: content.question.questionKey, answer: 'skip' })
    next({
      [content.question.questionKey]: { skipped: true },
    })
  }

  return (
    <CommonTemplate
      className={s.root}
      sidePanel={null}
      isPageLoading={isPageLoading}
      pageLogger={pageLogger}
      logo={<WixLogo className={s.wixLogo} />}
      onSkipClick={handleSkipClick}
      skipButton={content.skip && content.skip}
      skipButtonClassName={s.skipBtn}
    >
      <Box maxWidth="660px" margin="-60px auto 0" direction="vertical" paddingBottom="SP2">
        <Box align="left" direction="vertical" gap="SP2">
          <Heading dataHook={wixelSplitDataHooks.title()}>{question.content.title}</Heading>
          {Boolean(question.content.subtitle) && (
            <Text className={s.WixStudioSplit__subtitle}>{question.content.subtitle}</Text>
          )}
        </Box>
        <Box gap="SP3" align="center" marginTop="SP5" direction="vertical">
          {question.options.map(option => (
            <Option
              key={option.optionKey}
              imgSrc={option.img.content.src}
              title={option.label}
              description={option.description}
              onClick={handleClick(question.questionKey, option.optionKey)}
              dataHook={wixelSplitDataHooks.option({ key: option.optionKey })}
            />
          ))}
        </Box>
      </Box>
    </CommonTemplate>
  )
}
